var countdownStickyActive = false;

function getSiteHeaderHeight() {
  var siteHeader = document.querySelector('#SiteHeader');
  return siteHeader ? siteHeader.getBoundingClientRect().height : 0;
}

function updateCountdownPosition() {
  var countdownWrapper = document.querySelector('.countdown-wrapper');
  var siteHeight = getSiteHeaderHeight();
  if (window.scrollY > 250) {
    countdownWrapper.style.top = (siteHeight - 1) + 'px';
  }
}

function stickyCountDownTimer() {
  var siteHeader = document.querySelector('#SiteHeader');
  var countdownWrapper = document.querySelector('.countdown-wrapper');
  var headerStickyEnabled = siteHeader && siteHeader.dataset.sticky === 'true';
  var countdownStickyClass = 'site-countdown--stuck';
  var openTransitionClass = 'site-countdown--opening';

  if (!headerStickyEnabled) return;

  if (window.scrollY > 250) {
    if (countdownStickyActive) return;

    countdownStickyActive = true;
    siteHeader.classList.add('site-header--stuck');

    setTimeout(function() {
      updateCountdownPosition();
      countdownWrapper.classList.add(countdownStickyClass);

      setTimeout(function() {
        countdownWrapper.classList.add(openTransitionClass);
      }, 100);
    }, 0);
  } else {
    if (!countdownStickyActive) return;

    countdownStickyActive = false;
    countdownWrapper.classList.remove(openTransitionClass);
    countdownWrapper.classList.remove(countdownStickyClass);
    countdownWrapper.style.top = '';
  }
}

window.addEventListener('resize', function() {
  stickyCountDownTimer();
  updateCountdownPosition(); // Ensure position update after resize
});
window.addEventListener('load', function() {
  stickyCountDownTimer();
});
document.addEventListener('shopify:section:load', function() {
  stickyCountDownTimer();
});
document.addEventListener('shopify:section:select', function() {
  stickyCountDownTimer();
});
window.addEventListener('scroll', stickyCountDownTimer);
